import React, { useEffect, useState } from "react";
import "./AdminForm.css";

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  // ===== Fetch all messages =====
  const fetchMessages = async () => {
    try {
      setLoading(true);
      const res = await fetch(process.env.REACT_APP_API_URL+"/home/admin/getTouch");
      if (!res.ok) throw new Error("Failed to fetch messages");
      const data = await res.json();
      setMessages(data);
    } catch (err) {
      console.error("Error fetching messages:", err);
    } finally {
      setLoading(false);
    }
  };

  // ===== Delete a message =====
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this message?")) return;

    try {
      const res = await fetch(process.env.REACT_APP_API_URL+`/home/admin/getTouch/${id}`, {
        method: "DELETE",
      });
      if (res.ok) {
        setMessages((prev) => prev.filter((msg) => msg._id !== id));
      } else {
        console.error("Failed to delete message");
      }
    } catch (err) {
      console.error("Error deleting message:", err);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  return (
    <div className="admin-container">
      <h1>Admin Panel</h1>
      <div className="table-container">
        <h2>Stored Messages</h2>

        {loading ? (
          <p className="loading-text">Loading messages...</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>S.NO</th>
                <th>Name</th>
                <th>Email</th>
                <th>Message</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {messages.length === 0 ? (
                <tr>
                  <td colSpan="5" className="no-data">
                    No messages found
                  </td>
                </tr>
              ) : (
                messages.map((msg, i) => (
                  <tr key={msg._id}>
                    <td>{i + 1}</td>
                    <td>{msg.name}</td>
                    <td>{msg.email}</td>
                    <td>{msg.message}</td>
                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(msg._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
